export function createGoogleMapLink(lat:number,long:number){
    return `https://www.google.com/maps/@${lat},${long},15z`;
}